global.modules.set({
  is_booted: false,
  async init(context) {
    if (this.is_booted) {
      return;
    }
    this.is_booted = true;

    $('form.display_listings', context).on('submit', function (e) {
      e.preventDefault();
      var thisForm = $(this);
      const formData = new FormData(thisForm[0]);
      $.ajax({
        url: thisForm.attr('action'),
        data: formData,
        method: thisForm.attr('method'),
        elem: null,
        success: null
      });
    });

    let displayTypeBtn = document.querySelector('.display-type');
    if (displayTypeBtn) {
      displayTypeBtn.addEventListener('click', (e) => {
        let el = e.target.closest('.btn-show-order');
        if (el && el.dataset.displayType) {

          if (!el.classList.contains('active')) {
            $('.btn-show-order').removeClass("active")
            el.classList.add('active')
          }

          let type = el.dataset.displayType;
          let listingsList = el.closest('.listings-list');

          if (!listingsList.classList.contains(`display-type-${type}`)) {
            listingsList.setAttribute("class", `listings-list display-type-${type}`)
          }
        }
      })
    }
  }
})